<Teleport to="body">
  <button
    class="proba-assist-floating-btn btn btn-primary d-flex align-items-center justify-content-center"
    type="button"
    aria-label="Open DBE Assist"
    title="DBE Assist"
    @click="$emit('open-assistant')"
  >
    <i class="bi bi-chat-dots-fill"></i>
  </button>
</Teleport>
